import { Stack, styled } from '@mui/material';

import { theme } from '@/design-system';

export const FormStack = styled(Stack)({
  flexDirection: 'column',
  gap: '16px',
  width: '600px',
  maxWidth: '100%',
  boxSizing: 'border-box',
  padding: '8px 16px 16px',
});

export const RemovedBanner = styled(Stack)({
  flexDirection: 'row',
  alignItems: 'center',
  gap: '8px',
  padding: '8px',
  borderRadius: '8px',
  background: theme.colors.error.subtle,
});

export const Field = styled(Stack)({
  flexDirection: 'column',
  gap: '6px',
});

export const CreateLink = styled('button')({
  alignSelf: 'flex-start',
  marginTop: '6px',
  border: 0,
  background: 'transparent',
  padding: 0,
  cursor: 'pointer',
  color: theme.colors.text.brand,
  font: 'inherit',
  fontSize: '13px',
  fontWeight: 500,
  ':disabled': {
    opacity: 0.5,
    cursor: 'default',
  },
});

export const FooterRow = styled(Stack)({
  flexDirection: 'row',
  justifyContent: 'flex-end',
  gap: '12px',
  marginTop: '8px',
});

export const RequiredMark = styled('span')({
  color: theme.colors.text.error,
  marginLeft: '2px',
});

export const SuffixField = styled('div')({
  position: 'relative',
  width: '100%',
});

export const SuffixText = styled('span')({
  position: 'absolute',
  right: '16px',
  top: '50%',
  transform: 'translateY(-50%)',
  pointerEvents: 'none',
  color: theme.colors.white[40],
  fontSize: '14px',
  lineHeight: 1,
});

export const LabelRow = styled('div')({
  display: 'flex',
  alignItems: 'center',
  gap: '6px',
});

export const ContactEmpty = styled(Stack)({
  flexDirection: 'column',
  alignItems: 'center',
  gap: '12px',
  padding: '16px 12px',
});

export const SelectRaisedBg = styled('div')({
  '& button': {
    backgroundColor: theme.colors.background.raised,
  },
});
